export default "__VITE_ASSET__fZcJaygR__"